import React from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { Link } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import useDriverAppAnnouncement, {
  DOWNLOAD_URL,
} from "./useDriverAppAnnouncement";

const BannerAlert = styled(Alert)`
  border-radius: 0;
  justify-content: center;

  .MuiAlert-action {
    margin-left: 0;
  }
`;

const DriverAppBanner = () => {
  const { pathname } = useLocation();
  const { isVisible, dismiss } = useDriverAppAnnouncement();

  if (pathname !== "/" || !isVisible) {
    return null;
  }

  return (
    <BannerAlert severity="info" onClose={dismiss}>
      La nouvelle application mobile <b>FluidIT Driver</b> est arrivée !{" "}
      <Link
        href={DOWNLOAD_URL}
        target="_blank"
        rel="noopener noreferrer"
        color="inherit"
        underline="always"
      >
        Télécharger l&apos;application
      </Link>
    </BannerAlert>
  );
};

export default DriverAppBanner;
